import { Component, OnInit, Input } from '@angular/core';
import { SystemConfigurationModel } from '../shared/models/system-configuration-model.model';
import { SettingsService } from '../shared/services/settings.service';
import { ConfigurationService } from '@admin/shared/services/configuration.service';

import { PagingFilter } from '../../shared/models/paging-filter.model';
import { SystemConfigurationFilterModel } from '../shared/models/system-configuration-filter-model';

@Component({
  selector: 'hr-system-configuration',
  templateUrl: './system-configuration.component.html',
  styleUrls: ['./system-configuration.component.less'],
  standalone: false,
})
export class SystemConfigurationComponent implements OnInit {
  @Input() filter: string;

  settings: SystemConfigurationModel[];

  filteredSettings: SystemConfigurationModel[];

  filterPagingWrapper: PagingFilter<SystemConfigurationFilterModel>;

  constructor(
    private settingsService: SettingsService,
    private config: ConfigurationService
  ) {
    this.filterPagingWrapper = new PagingFilter(
      new SystemConfigurationFilterModel()
    );
  }

  ngOnInit() {
    let config = this.config.getCachedConfig();
    this.loadSystemConfigurations();
  }

  public loadSystemConfigurations() {
    this.settingsService
      .ListSystemConfigurations(this.filterPagingWrapper)
      .subscribe((data) => {
        this.settings = data.items;
        this.filteredSettings = this.settings;
      });
  }

  public onFilterChanged() {
    if (!this.filter) {
      this.filteredSettings = this.settings;
      return;
    }
    this.filteredSettings = this.settings.filter(
      (s) => s.name.toLowerCase().indexOf(this.filter.toLowerCase()) >= 0
    );
  }
}
